<div
  class="user-avatar cursor-pointer"
  [ngbPopover]="userPopover"
  [directivePopoverConfig]="popoverConfig"
  popoverClass="user-profile-popover-wrapper"
  autoClose="outside"
  triggers="click"
  placement="bottom-end">
  <component-user-avatar [user]="user()" [size]="32" />
</div>

<ng-template #userPopover>
  <div class="user-profile-popup rounded-5">
    <!-- User Info Section -->
    <div class="d-flex flex-column gap-2 p-3 border-bottom">
      <span class="profile-badge">{{ planName() }}</span>

      <div class="profile-info">
        <div class="profile-name text-truncate">{{ displayName() }}</div>
        <div class="profile-email d-flex align-items-center gap-2">
          <span class="text-truncate">{{ email() }}</span>
          @if (!user()?.emailConfirmed && !user()?.isTemporary) {
            <span class="badge badge-primary text-xs">Not confirmed</span>
          }
        </div>
      </div>

      <button type="button" class="btn profile-button btn-secondary" (click)="onViewProfile()">View profile</button>
    </div>

    <!-- Menu Items -->
    <div class="profile-menu">
      <button type="button" class="profile-menu-item" (click)="onGiveFeedback()">
        <custom-icon name="messageCircleText" [size]="20" viewBox="0 0 24 24" class="menu-icon" />
        <span class="menu-label">Give feedback</span>
      </button>

      <button
        *hasRole="[UserRole.ORGANIZATION_ADMIN, UserRole.SUPER_ADMIN]"
        type="button"
        class="profile-menu-item"
        (click)="onPricing()">
        <custom-icon name="magicStick" [size]="20" viewBox="0 0 20 20" class="menu-icon" />
        <span class="menu-label">Pricing</span>
      </button>

      <button type="button" class="profile-menu-item border-bottom" (click)="toggleTheme()">
        <custom-icon name="moon" [size]="20" viewBox="0 0 20 20" class="menu-icon" />
        <span class="menu-label">Dark mode</span>
        <component-toggle [checked]="themeService.currentTheme() === 'dark'" (checkedChange)="toggleTheme()" />
      </button>

      <button type="button" class="profile-menu-item profile-menu-item-last" (click)="onLogout()">
        <custom-icon name="logout" [size]="20" viewBox="0 0 20 20" class="menu-icon" />
        <span class="menu-label">Log out</span>
      </button>
    </div>
  </div>
</ng-template>
